import { skipToken } from '@reduxjs/toolkit/query';
import RightAPI from '../api/RightAPI';
import {
  RightAPIResponse,
  RightUserSimpleAPIResponse,
} from '../api/right.model';
import { useMemo } from 'react';
import _ from 'lodash';
import { orComparator } from '../../../util/lodash/orComparator';

function useUserRolesGroup(groupId?: string) {
  const { data: roles, ...restRoles } = RightAPI.useGetRolesQuery(undefined);
  const { data: userRoles, ...restUserRoles } =
    RightAPI.useGetGroupUserRolesQuery(groupId ?? skipToken);

  const data = useMemo(() => {
    if (userRoles) {
      const userRolesById: Record<
        string,
        (RightUserSimpleAPIResponse & { role?: RightAPIResponse })[]
      > = {};
      for (const userId in userRoles) {
        const userRole = userRoles[userId];
        const userRolesWithRole = userRole.map((useRole) => ({
          ...useRole,
          role: roles?.entities[useRole.id],
        }));
        userRolesById[userId] = userRolesWithRole;
      }
      return userRolesById;
    }
  }, [userRoles, roles]);
  const response = useMemo(
    () =>
      _.chain({ ...restRoles, data })
        .mergeWith(restUserRoles, orComparator)
        .value(),
    [restRoles, restUserRoles, data]
  );
  return response;
}

export default useUserRolesGroup;
